import {
  getAuditDetails,
  getAuditFieldInfo,
  AuditService,
  AuditActionType,
} from 'shared/userAudit/audit-constants';
import { Operation, AuditDetails } from 'data/types';
import { SshSecurityInfo } from 'data/sshSecurityInfo/sshSecurityInfo.types';

// eslint-disable-next-line import/prefer-default-export
export function getAuditDetailsToSubmit(
  dialedDigitExtractionServerData: SshSecurityInfo,
  originalDigitExtractionServerFormData: SshSecurityInfo | null,
  isAuditEnabled: boolean,
  userId: string,
  userName: string,
  operation: Operation,
): AuditDetails {

  let actionType = AuditActionType.SECURITY_INFO_ADD;
  let isEdit = false;
  if (operation === 'UPDATE') {
    actionType = AuditActionType.SECURITY_INFO_EDIT;
    isEdit = true;
  }

  const auditDetails = getAuditDetails(
    isAuditEnabled,
    userId,
    userName,
    getAuditFieldInfo(dialedDigitExtractionServerData, null, isEdit, originalDigitExtractionServerFormData),
    dialedDigitExtractionServerData.id,
    AuditService.SECURITY_INFO,
    actionType,
  );
  return auditDetails as AuditDetails;
}
